import { Box, Heading } from "@chakra-ui/layout"
import { Flex } from "@chakra-ui/react"

export function Fact({ factValue, factDescription, factColor }) {
  return (
    <Flex
      justifyContent="center"
      flexWrap={{ base: `wrap`, md: `nowrap` }}
      padding={{ base: `40px 0`, md: "80px 0" }}
    >
      <Box
        alignSelf="center"
        flex={{ base: `0 0 100%`, md: `0 0 auto` }}
        mr={{ base: 0, md: "40px" }}
      >
        <Heading
          color={factColor}
          fontWeight="700"
          paddingX={{ base: 0, md: "50px" }}
          fontSize={{ base: `101px`, md: `190px` }}
          textAlign={{ base: `center`, md: `left` }}
        >
          {factValue}
        </Heading>
      </Box>
      <Box alignSelf="center" flex={{ base: `0 0 100%`, md: `0 0 auto` }}>
        <Box
          maxW={{ base: `288px`, md: "400px" }}
          m={{ base: `0 auto`, md: 0 }}
        >
          <Heading
            fontWeight="500"
            fontSize={{ base: `24px`, md: "36px" }}
            color="black"
            lineHeight={{ base: `27px`, md: "40px" }}
            textTransform="uppercase"
            textAlign={{ base: `center`, md: `left` }}
          >
            {factDescription}
          </Heading>
        </Box>
      </Box>
    </Flex>
  )
}
